import { FILE_MODERATION_STATUSES, FILE_UPLOAD_STATUSES, MAX_FILE_SIZE } from '@lifk/types';
import { z } from 'zod';
export const UploadUrlValidationSchema = z.object({
    fileName: z.string(),
    fileType: z.string(),
    fileSize: z
        .number()
        .max(MAX_FILE_SIZE, `File size must not exceed ${MAX_FILE_SIZE} bytes (30MB)`),
    workshopId: z.string()
});
export const FileAttachmentValidationSchema = z.object({
    fileName: z.string(),
    fileKey: z.string(),
    fileType: z.string(),
    fileSize: z
        .number()
        .max(MAX_FILE_SIZE, `File size must not exceed ${MAX_FILE_SIZE} bytes (30MB)`),
    workshopId: z.string()
});
export const FileAttachmentParamsSchema = z.object({
    id: z.string()
});
export const FileAttachmentUploadSchema = z.object({
    workshopId: z.string(),
    fileName: z.string().optional(),
    fileKey: z.string().optional(),
    fileType: z.string().optional(),
    fileSize: z.number().optional()
});
export const PresignRequestSchema = z.object({
    workshopId: z.string(),
    fileName: z.string(),
    contentType: z.string(),
    size: z
        .number()
        .positive()
        .max(MAX_FILE_SIZE, `File too large (>${MAX_FILE_SIZE} bytes)`)
});
export const FileAttachmentsUpdateValidationSchema = z.object({
    key: z.string().min(2).max(100),
    status: z.enum(FILE_MODERATION_STATUSES).nullable(),
    violations: z.array(z.string()).optional()
});
export const FileModerationUpdateValidationSchema = z.object({
    key: z.string().min(2).max(100),
    moderationStatus: z.enum(FILE_MODERATION_STATUSES).optional().nullable(),
    violations: z.array(z.string()).optional(),
    uploadStatus: z.enum(FILE_UPLOAD_STATUSES).optional()
});
//# sourceMappingURL=fileAttachment.js.map